"use client";
import Image from "next/image";
import { cn } from "@/lib/utils";
import loading from "@/../public/assets/loading.gif";

type Props = {
	className?: string;
	/** When false, no fixed full-screen overlay (avoids layout blink on admin/directory-style pages). */
	fullScreen?: boolean;
	/**
	 * When fullScreen=false: `section` = padded centered block (lists, pagination slot);
	 * `inline` = compact wrapper for buttons/icons (no black backdrop, no large padding).
	 */
	layout?: "section" | "inline";
};

export default function LoadingSpinner({
	className,
	fullScreen = true,
	layout = "section",
}: Props) {
	const img = (
		<Image
			draggable="false"
			src={loading}
			alt="loading"
			className={cn(layout === "inline" ? "h-8 w-8" : "h-20 w-20", className)}
			unoptimized
			priority
		/>
	);

	if (!fullScreen) {
		if (layout === "inline") {
			return (
				<span
					className="inline-flex shrink-0 items-center justify-center"
					aria-busy="true"
					role="status"
				>
					{img}
				</span>
			);
		}
		return (
			<div className="flex w-full items-center justify-center py-16" aria-busy="true">
				{img}
			</div>
		);
	}

	return (
		<div className="loading-backdrop fixed left-0 top-0 z-50 flex h-screen w-screen items-center justify-center">
			{img}
		</div>
	);
}
